import React from 'react';

export const About = () => {
  
  return (
    <div className='container '>
      <h2 style={{color:"#f2f2f2"}}>Your Notebooks On Cloud</h2>
    <a className='text-bg-primary p-1 m-2 text-decoration-none' rel='noreferrer' href='https://github.com/jamilahmed2' target="_blank">&copy; by Jamil Ahmed</a>
    <a className='text-bg-info p-1 m-2 text-decoration-none' rel='noreferrer' href='https://github.com/jamilahmed2/Notebooks' target="_blank">GITHUB Repo</a>
    </div>
  )
}
